<!-- filepath: src/components/MaintenanceModal.vue -->
<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h2>Em Manutenção</h2>
      <p>Esta funcionalidade está temporariamente indisponível devido a manutenção.<br>
      Por favor, tente novamente mais tarde.</p>
      <button @click="$emit('close')">Fechar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenanceModal",
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
  padding: 2rem 2.5rem;
  border-radius: 16px;
  min-width: 340px;
  text-align: center;
  box-shadow: 0 4px 24px rgba(30, 41, 59, 0.25);
  border: 2px solid #1976d2;
}
h2 {
  color: #1976d2;
  margin-bottom: 1rem;
  letter-spacing: 1px;
}
p {
  color: #334155;
  font-size: 1.08rem;
}
button {
  margin-top: 1.5rem;
  padding: 0.6rem 2.2rem;
  border: none;
  background: linear-gradient(90deg, #1976d2 0%, #38bdf8 100%);
  color: #fff;
  border-radius: 6px;
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(56, 189, 248, 0.12);
  transition: background 0.2s, transform 0.2s;
}
button:hover {
  background: linear-gradient(90deg, #125ea2 0%, #0ea5e9 100%);
  transform: translateY(-2px) scale(1.04);
}
</style>

